<template>
    <schedule-edit-dialog-event-main-container
        v-if="event.event_class === Event.CLASS_EVENT"
        :record="record"
        :event="event"
    />
    <schedule-edit-dialog-default-main-container v-else :record="record" :event="event" />
</template>

<script>
import { Schedule } from '@/models/Schedule';
import { Event } from '@/models/Event';
import ScheduleEditDialogEventMainContainer from '@/components/schedule/EditDialogEventMainContainer.vue';
import ScheduleEditDialogDefaultMainContainer from '@/components/schedule/EditDialogDefaultMainContainer.vue';

export default {
    name: 'ScheduleEditDialogMainContainer',
    components: {
        ScheduleEditDialogEventMainContainer,
        ScheduleEditDialogDefaultMainContainer,
    },

    props: {
        event: Event,
        record: Schedule,
    },

    created() {
        this.Event = Event;
        this.Schedule = Schedule;
    },
};
</script>
